export const imageDropZoneIdPrefix = 'image-drop-zone';
